// extracted by mini-css-extract-plugin
export default {"sectionRow":"information_sectionRow__ohbpU","contactsList":"information_contactsList__1Nmuo"};